import React, { useState } from 'react';

import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from "@material-ui/core/IconButton";
import HelpIcon from '@material-ui/icons/Help';

import { BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import Modal from 'react-modal';
import { toast } from 'react-toastify';

export const AddIcon = (props) => {

  const [open, setOpen] = useState(false);

  const addButtonClick = (helptext) => {
    setOpen(true);
  };

  let dataMin = 9999;
  let dataMax = -9999;
  if (props.data) {
    dataMin = Math.min(...props.data.map((d) => d.x));
    dataMax = Math.max(...props.data.map((d) => d.x));
    dataMin -= Math.round((dataMax - dataMin) / 2 * 0.2);
    dataMax += Math.round((dataMax - dataMin) / 2 * 0.2);
  }

  const customStyles = {
    content: {
      top: "0%",
      left: "25%",
      right: "25%",
      bottom: "10%",
      minWidth: "50%",
    },
  };

  /**
   * Formats the help text to include line breaks.
   * @param {string} msg - The help text to format.
   * @returns {JSX.Element} - The formatted help text.
   */
  const textIndention = (msg) => {
    const texts = msg.split("\n").map((item, index) => {
      return (
        <p key={index}>{item}<br /></p>
      );
    });
    return <div>{texts}</div>;
  }

  /**
   * Handles a click event on a bar in the chart.
   * @param {Object} data - The data object associated with the clicked bar.
   * @param {number} index - The index of the clicked bar.
   */
  const handleBarClick = (data, index) => {
    // console.log(data)
    // console.log(data.payload)
    // console.log(index)
    let e = new Object()
    e.target = new Object()
    e.target.name = props.name
    e.target.value = data.payload.x
    props.onBarClick(e)

    toast.info('Selected value: ' + data.payload.x, {autoClose: 500})
  }

  return (
    <>
      <IconButton onClick={() => addButtonClick(props.helptext)}>
        <InputAdornment position="start" >{props.unit}</InputAdornment>
        <HelpIcon />
      </IconButton>

      <Modal style={customStyles} isOpen={open} ariaHideApp={false} onRequestClose={() => setOpen(false)}>
        <div style={{width: '500px', height: '300px', margin: '100px auto', background: '#fff', padding: '20px'}}>
          <h1>{props.title}</h1>
          {/* <p>{props.helptext}</p> */}
          {textIndention(props.helptext)}
          {(props.imgSrc) &&
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center'}} >
            <img src={props.imgSrc} style={{width: '100%'}} />
          </div>}
          {(props.imgSrc1) &&
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center'}} >
            <img src={props.imgSrc1} style={{width: '100%'}} />
          </div>}
         
          {(props.data) && (process.env.AI == 1) &&
          <div>
            <p>Distribution:</p>
            <BarChart width={460} height={250} data={props.data}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey='x' type='number' domain={[dataMin, dataMax]} />
              <YAxis dataKey='y' type='number' />
              <Tooltip />
              <Legend />
              <Bar dataKey='y' name='Actual distibution' fill='#8884d8' barSize={10} onClick={handleBarClick}/>
              <Bar dataKey='ai' name='AI estimation' fill="#82ca9d" barSize={10} onClick={handleBarClick}/>
            </BarChart>
          </div>}

          {/* add space */}
          <div style={{height: '50px'}} />
          
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center'}} >
            <button onClick={() => setOpen(false)}>Close</button>
          </div>
        </div>
      </Modal>
    </>
  );
};